import { createFileRoute } from '@tanstack/react-router';
import { MotionLandingPage } from '@/components/motion/MotionLandingPage';

export const Route = createFileRoute('/motion')({
  component: MotionPreviewRoute,
});

function MotionPreviewRoute() {
  return <MotionLandingPage mode='preview' />;
}
